import Entity from "lib/models/Entity";
import { computed } from "mobx";

interface Result {
  [key: string]: number;
}

interface BlockInfoSource {
  textArray: string[];
  categoryAuto: string[];
  categoryManual: string[] | null;
  result: Result;
  feedback: string | null;
}

export default class BlockInfo extends Entity<BlockInfoSource> {
  @computed
  get text(): string[] {
    return this.source.textArray;
  }

  @computed
  get categoryAuto(): string[] {
    return this.source.categoryAuto;
  }

  @computed
  get categoryManual(): string[] | null {
    return this.source.categoryManual ? this.source.categoryManual : null;
  }

  @computed
  get result(): Result {
    return this.source.result;
  }

  @computed
  get feedback(): string {
    return this.source.feedback || "";
  }
}

export type { BlockInfoSource };
